import { useState } from 'react';
import { X } from 'lucide-react';
import hamburgerIcon from '../../assets/hamburger.svg';
import logo from '../../assets/RM Logo Black 1.png';
import home from '../../assets/homer.svg';
import { HashLink as Link } from 'react-router-hash-link';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      {/* ÜST NAVBAR */}
      <nav className="flex items-center justify-between lg:justify-center gap-4 lg:gap-40 px-4 lg:px-10 py-4 bg-white relative">
        {/* Sol: Logo */}
        <div className="flex items-center">
          <a href="/">
            <img src={logo} alt="Logo" className="h-8 lg:h-16" />
          </a>
        </div>

        {/* Orta Kısım (MASAÜSTÜNDE GÖRÜNÜR, TABLET & MOBİLDE GİZLİ) */}
        <div
          style={{ backgroundColor: '#22282B' }}
          className="hidden lg:flex rounded-full px-2 py-1 items-center space-x-2"
        >
          <button className="text-[#22282B] flex items-center gap-1 px-4 py-1.5 bg-white rounded-full font-medium">
            <img src={home} alt="Home" className="h-4 w-4" />
            <Link smooth to="/#home"    className="text-[#22282B]">Home</Link>
          </button>
          <button
            className="text-white px-3 py-1 hover:underline"
            onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
          >
         <Link smooth to="/#about"   className="text-white ">About Us</Link>
          </button>
          <button className="text-white px-3 py-1 hover:underline">
            <a
              href="https://careers.realminds.co/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white"
            >
              Careers
            </a>
          </button>
          <button
            className="text-white px-3 py-1 hover:underline"
            onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}
          >
     <Link smooth to="/#projects"className="text-white ">Projects</Link>
          </button>
          <button
            className="text-white px-3 py-1 hover:underline"
            onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
          >
        <Link smooth to="/#services"className="text-white ">Services</Link>
          </button>
          <button
            className="text-white px-3 py-1 hover:underline"
            onClick={() => document.getElementById('locations')?.scrollIntoView({ behavior: 'smooth' })}
          >
            <Link smooth to="/#locations"className="text-white">Locations</Link>
          </button>
        </div>

        {/* Sağ: Contact Us (MASAÜSTÜNDE GÖRÜNÜR) */}
        <Link
         smooth
          to="/#footer"
          className="border font-sans border-black rounded-full py-3 px-5 text-black hover:bg-gray-100 hidden lg:block"
        >
         Contact Us
        </Link>
        {/* Tablet & Mobil Hamburger Butonu */}
        <div className="lg:hidden">
          <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? (
              <X className="h-8 w-8 text-black" />
            ) : (
              <img src={hamburgerIcon} alt="Menu" className="h-8 w-8" />
            )}
          </button>
        </div>
      </nav>

      {/* TABLET & MOBIL MENU */}
      {isMenuOpen && (
        <div className="lg:hidden flex flex-col items-center gap-4 bg-white border-t pt-4">
          <div
            style={{ backgroundColor: '#22282B' }}
            className="rounded-full px-2 py-1 flex items-center justify-around mb-4"
          >
            <button className="flex items-center gap-1 px-3 py-1.5 bg-white rounded-full font-medium text-[#22282B]">
              <img src={home} alt="Home" className="h-3 w-3" />
              <span>Home</span>
            </button>
 
  <Link smooth to="/#about"   className="text-white …">About Us</Link>

  <Link smooth to="/#projects"className="text-white …">Projects</Link>
  <Link smooth to="/#services"className="text-white …">Services</Link>
  <Link smooth to="/#locations"className="text-white …">Locations</Link>
          </div>
        </div>
      )}
    </>
  );
}
